"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethereum = exports.tendermint = exports.cosmos = exports.isInstalled = exports.InstallError = void 0;
var cosmosFunctions = __importStar(require("./cosmos"));
var error_1 = require("./error");
Object.defineProperty(exports, "InstallError", { enumerable: true, get: function () { return error_1.InstallError; } });
var tendermintFunctions = __importStar(require("./tendermint"));
function isInstalled() {
    return !!window.cosmostation;
}
exports.isInstalled = isInstalled;
function cosmos() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(cosmosFunctions);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new error_1.InstallError());
        }, 500);
    });
}
exports.cosmos = cosmos;
function tendermint() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(tendermintFunctions);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new error_1.InstallError());
        }, 500);
    });
}
exports.tendermint = tendermint;
function ethereum() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(window.cosmostation.ethereum);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new error_1.InstallError());
        }, 500);
    });
}
exports.ethereum = ethereum;
